import Primary from "../layouts/Primary";
import {t} from "../../i18n";
import {QRCodeSVG} from 'qrcode.react';

import './OnlineResults.css'
import {DisplayCommand, ShowOnlineResults} from "../../javaTypes";

export default function OnlineResults({command} : {
    command: DisplayCommand<ShowOnlineResults>
}) {
    return <Primary className={"onlineResults"}>
            <span
              className={"resultsDescription"}>{t`Results and rankings can be viewed on your mobile device or your computer at this website:`}</span>
            <div className={"qrWrapper"}>
                <QRCodeSVG value={command.params.url} size={580} />
                <span>{command.params.url.replace(/https?:\/\//, '')}</span>
            </div>
    </Primary>;
}